// KORLÁTOZOTT CSOPORTOS TÉTELEK JELZÉSE — a hívó csak azt tudja meg, hogy VAN ilyen tétel (darabszám), az összeg,
// a tételek és a többi fiók neve nem látszik. Mikor: a csoportos számla / díj olyan fiókot is érint, amihez a
// hívónak nincs „Szolgáltatások és díjak" joga. A szám a szerverről jön (a szűrést ő végzi); a felület csak jelzi.
// Két helyen áll (havi áttekintés, számla-lista), ezért közös.
//
// TÓNUS: `neutral` (design.md „AttentionBanner"): mellékes állapot-információ, amire a partner NEM tud reagálni
// (nincs mit tennie — a jogot a fiók adminja adja). `warning` tennivalót jelentene, ezért nem az; a zöld `info`
// pedig „sikernek" olvasódna.
import { useTranslation } from 'react-i18next';

import { AttentionBanner } from '@/components/shared/attention-banner';

export function PortalHiddenSharedNotice({
  count,
  kind = 'items',
  className,
}: {
  count: number;
  /** `items` = vegyes tétel-szám (havi nézet) · `invoices` = csak számlák (számla-lista). */
  kind?: 'items' | 'invoices';
  className?: string;
}): JSX.Element | null {
  const { t } = useTranslation();
  if (count <= 0) return null;
  return (
    <div data-testid="portal-hidden-shared-notice">
      <AttentionBanner
        tone="neutral"
        {...(className !== undefined ? { className } : {})}
        title={t(
          kind === 'invoices'
            ? 'portal.billing.hiddenShared.noticeInvoices'
            : 'portal.billing.hiddenShared.notice',
          { count },
        )}
      />
    </div>
  );
}
